module.exports = __webpack_public_path__ + "img/25-800x800.1020a415.jpg";